<template>
    <div class="">
        <el-page-header @back="goBack"
            :content="isLook == 1 ? '详情' : ruleForm.id > 0 ? '编辑交易项目' : '新增交易项目'"></el-page-header><br />
        <el-alert class="mb20" title="下方字段填写将直接影响前台数据的展示以是否能顺利审核通过，请认真填写。" type="warning" show-icon>
        </el-alert>
        <div class="info_box">
            <div class="card_tit mb20">项目主体信息</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="135px" class="demo-ruleForm"
                label-position="right">
                <el-divider content-position="left">项目内容</el-divider>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="项目编号" prop="xhProject.no">
                            <el-input disabled v-model="ruleForm.xhProject.no" placeholder="保存时自动生成" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="项目名称" prop="xhProject.name">
                            <el-input disabled v-model="ruleForm.xhProject.name" placeholder="自动匹配项目转出信息的名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="发布区域" prop="xhProject.allCode">
                            <el-cascader :disabled="isLook == 1 ? true : false" v-model="allCode" :options="areaList"
                                @change="handleChange" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="流转开始时间" prop="xhProject.transferStartDate">
                            <el-date-picker :disabled-date="disabledDate" :disabled="isLook == 1 ? true : false"
                                v-model="ruleForm.xhProject.transferStartDate" type="date" value-format="YYYY-MM-DD"
                                placeholder="选择流转开始时间" class="!w-1/1" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="流转结束时间" prop="xhProject.transferEndDate">
                            <el-date-picker :disabled-date="disabledDateOne" :disabled="isLook == 1 ? true : false"
                                v-model="ruleForm.xhProject.transferEndDate" type="date" value-format="YYYY-MM-DD"
                                placeholder="选择流转结束时间" class="!w-1/1" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">项目转出人信息</el-divider>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="类型" prop="xhProjectOut.type">
                            <el-select :disabled="true" v-model="ruleForm.xhProjectOut.type" clearable filterable
                                placeholder="请选择类型">
                                <el-option label="个人" value="2" />
                                <el-option label="企业" value="1" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="姓名" prop="xhProjectOut.name">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.name" placeholder="请输入名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="电话" prop="xhProjectOut.phone">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.phone" placeholder="请输入电话" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="8" v-if="ruleForm.xhProjectOut.type == 1">
                        <el-form-item label="法人姓名" prop="xhProjectOut.legal">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.legal" placeholder="请输入法人姓名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="身份证" prop="xhProjectOut.idCard">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.idCard" placeholder="请输入身份证" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="银行预留手机号" prop="xhProjectOut.bankPhone">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.bankPhone"
                                placeholder="请输入银行预留手机号" />
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                    <el-form-item label="开户行名称" prop="xhProjectOut.bankName">
                      <el-input :disabled="true" v-model="ruleForm.xhProjectOut.bankName"
                                placeholder="请输入开户行名称名称" />
                    </el-form-item>
                  </el-col>
                    <el-col :span="8">
                        <el-form-item label="账户名称" prop="xhProjectOut.bankAccountName">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.bankAccountName"
                                placeholder="请输入账户名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="银行卡号" prop="xhProjectOut.bankNo">
                            <el-input :disabled="true" v-model="ruleForm.xhProjectOut.bankNo" placeholder="请输入银行卡号" />
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-divider content-position="left">项目转出信息</el-divider>
                <el-row :gutter="24">

                    <el-col :span="8">
                        <el-form-item label="项目名称" prop="xhProjectOutMsg.name">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="ruleForm.xhProjectOutMsg.name"
                                placeholder="请输入项目名称" @change="changeName" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="挂牌价格" prop="xhProjectOutMsg.price">
                            <el-input-number :disabled="isLook == 1 ? true : false"
                                v-model="ruleForm.xhProjectOutMsg.price" :precision="2" :step="1" :min="0" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="挂牌价格单位" prop="xhProjectOutMsg.priceUnit">
                            <el-select :disabled="isLook == 1 ? true : false"
                                v-model="ruleForm.xhProjectOutMsg.priceUnit" clearable filterable
                                placeholder="请选择挂牌价格单位">
                                <el-option label="元(总价)" value="1" />
                                <el-option label="元/年" value="2" />
                                <el-option label="元/亩" value="4" />
                                <el-option label="元/亩/年" value="3" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                  <el-col :span="8">
                    <el-form-item label="土地性质" prop="xhProjectOutMsg.landType">
                      <el-select :disabled="isLook == 1 ? true : false"
                                 v-model="ruleForm.xhProjectOutMsg.landType" clearable filterable placeholder="请选择土地性质">
                        <el-option label="个人" value="1" />
                        <el-option label="集体" value="2" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-divider content-position="left">项目地块信息</el-divider>
                <el-row :gutter="24">
                    <el-col :span="6" style="margin-bottom: 20px;" v-for="(item, index) in ruleForm.xhProjectLandList"
                        :key="index">
                        <el-card shadow="hover">
                            <template #header >
                                <div class="card-header flex_between" >
                                    <span>{{ item.name }}</span>
                                    <el-icon @click="deletePlot(index)" v-if="isLook != 1" >
                                        <CloseBold />
                                    </el-icon>
                                </div>
                            </template>
                            <p class="text item">地块面积 {{ item.area }}(亩)</p>
                            <p class="text item">地块位置 {{ item.address }}</p>

                            <template #footer>
                                <div class="flex_end cursor" @click="editPlot(item, index)" v-if="isLook != 1">
                                    编辑
                                </div>
                              <div class="flex_end cursor" @click="editPlot(item, index)" v-else>
                                查看
                              </div>
                            </template>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row justify="center" v-if="isLook != 1">
                    <el-button type="primary" @click="addProjectPlot" round>+ 添加项目地块</el-button>
                </el-row>
                <el-divider content-position="left">项目宣传图信息</el-divider>
                <el-row :gutter="24">
                    <el-col :span="8" v-if="isLook != 1">
                        <el-form-item label="上传宣传图片" prop="fileName">
                            <el-upload class="upload-demo" :show-file-list="false"
                                accept="image/jpeg,image/png,image/gif" :headers="headers" action="/api/common/upload"
                                :before-upload="beforeUpload" multiple :on-success="(response) => handleSuccess(response, 4)" >
                                <el-button type="primary">点击上传宣传图片</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="24">
                    <el-form-item label="宣传图片列表" prop="fileName">
                        <div class="attachment_box" v-for="(items, index) in ruleForm.xhProjectFileList">
                            <div class="mr20 close_icon color_fff flex_end" v-if="isLook != 1 && items.type == 4">
                                <el-icon @click="closeFile(index)">
                                    <CloseBold />
                                </el-icon>
                            </div>
                            <div class="attachment_info flex_center" v-if="items.type == 4">
                                <el-image style="width: 150px; height: 150px" :src="items.filePath"
                                    :preview-src-list="[items.filePath]" fit="contain" />
                            </div>
                        </div>
                    </el-form-item>
                </el-row>
                <el-form-item v-if="isLook != 1" class="flex_end">
                    <el-button type="primary" @click="submitForm('ruleForm', 1)">保存项目草稿</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm', 2)">立即提交项目审核</el-button>
                </el-form-item>
            </el-form>
        </div>

        <drawMap ref="drawMapRef" @hideDialog="obtainCoordinates" />

        <el-dialog title="编辑地块" v-model="plotInfoDialog" :before-close="handleClose" width="60%">
            <el-form :model="xhProjectLand" :rules="xhProjectLandRules" ref="xhProjectLandRuleForm" label-width="110px"
                class="demo-ruleForm">
                <el-row :gutter="24">

                    <el-col :span="8">
                        <el-form-item label="地块名称" :rules="{
                            required: true,
                            message: '请填写地块名称',
                            trigger: 'blur',
                        }">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.name"
                                placeholder="请输入地块名称" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="面积(亩)" :rules="{
                            required: true,
                            message: '请填写面积(亩)',
                            trigger: 'blur',
                        }">
                            <el-input-number :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.area"
                                :precision="2" :step="1" :min="0" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="东至" :rules="{
                            required: true,
                            message: '请填写东至',
                            trigger: 'blur',
                        }">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.east"
                                placeholder="请输入东至" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="西至" :rules="{
                            required: true,
                            message: '请填写西至',
                            trigger: 'blur',
                        }">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.west"
                                placeholder="请输入西至" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="南至" :rules="{
                            required: true,
                            message: '请填写南至',
                            trigger: 'blur',
                        }">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.south"
                                placeholder="请输入南至" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="北至" :rules="{
                            required: true,
                            message: '请填写北至',
                            trigger: 'blur',
                        }">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.north"
                                placeholder="请输入北至" />
                        </el-form-item>
                    </el-col>


                    <el-col :span="8">
                        <el-form-item label="位置" :rules="{
                            required: true,
                            message: '请填写位置',
                            trigger: 'blur',
                        }">
                            <el-input :disabled="isLook == 1 ? true : false" v-model="xhProjectLand.address"
                                placeholder="请输入位置" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="坐标范围" :rules="{
                            required: true,
                            message: '请选择坐标范围',
                            trigger: 'blur',
                        }">
                            <div v-for="(itemss, x) in xhProjectLand.coorList" :key="x">
                                <el-tag type="primary" style="margin-right: 10px;">{{ xhProjectLand.coorList[x]
                                    }}</el-tag>
                            </div>

                            <el-icon v-if="isLook != 1" style="font-size: 20px;color: #2D97FF;margin-right: 10px;"
                                @click="addCoor(indexs)">
                                <CirclePlusFilled />
                            </el-icon>
                            <el-icon v-if="isLook != 1" style="font-size: 20px;" @click="xhProjectLand.coorList = []">
                                <CircleCloseFilled />
                            </el-icon>
                        </el-form-item>
                    </el-col>

                    <el-card style="margin: 0 auto;width: 100%;" shadow="never">
                        <el-tabs v-model="subTabsName" class="-mt-15px -mb-10px">
                            <el-tab-pane label="附着物" name="item">
                                <el-row :gutter="24" v-for="(item, index) in xhProjectLand.attachmentsList"
                                    :key="index">
                                    <el-form-item label="附着物描述" :rules="{
                                        required: true,
                                        message: '请填写附着物描述',
                                        trigger: 'blur',
                                    }">
                                        <el-input type="textarea" style="width: 400px;"
                                            :disabled="isLook == 1 ? true : false" v-model="item.name"
                                            placeholder="请输入附着物描述" />
                                        <el-button style="margin-left: 10px;" type="danger" circle
                                                   v-if="isLook != 1"
                                            @click="deleteAttachment(index)">
                                            <el-icon>
                                                <Delete />
                                            </el-icon>
                                        </el-button>
                                    </el-form-item>
                                </el-row>

                                <el-row justify="center" class="mt-3" v-if="formType != '5' && formType != '2'" >
                                    <el-button @click="addAttachments(item, index)" v-if="isLook != 1"  round>+ 添加附着物</el-button>
                                </el-row>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </el-row>
            </el-form>

            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="savePlot" v-if="isLook != 1">
                        保存地块
                    </el-button>
                    <el-button @click="handleClose">取消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { projectDetail, realNameInfo, areaList, projectApply, projectUpdate, getDict } from "@/utils/api";
import drawMap from "@/components/drawMap.vue";
var moment = require("moment");
export default {
    components: {
        drawMap
    },
    data() {
        return {
            fileList: [],
            isSave: false,
            subTabsName: "item",
            allCode: ["510000", "511700", "511781"],
            ruleForm: {
                xhProject: {
                    id: "",
                    parentId: "",
                    allCode: "510000,511700,511781",
                    no: "",
                    name: "",
                    status: "",
                    // bidType: "",
                    transferStartDate: "",
                    transferEndDate: "",
                    projectType:1,
                    // bidPrice:""
                },
                xhProjectOut: {
                    id: "",
                    projectId: "",
                    type: "",
                    name: "",
                    phone: "",
                    legal: "",
                    idCard: "",
                    bankPhone: "",
                    bankAccountName: "",
                    bankName:"",
                    bankNo: "",
                },
                xhProjectOutMsg: {
                    id: "",
                    projectId: "",
                    name: "",
                    price: "",
                    priceUnit: "",
                    // depositFlag: "",
                    // depositFee: "",
                    landType: "",
                },
                xhProjectLandList: [],
                xhProjectFileList: []
            },
            uploadParams: {
                id: 123,
                type: 1,
            },
            rules: {
                // 项目主体信息
                "xhProject.allCode": [{ required: true, message: "请填写项目编号", trigger: "blur" }],
                "xhProject.transferStartDate": [{ required: true, message: "请选择发布日期", trigger: "change" }],
                "xhProject.transferEndDate": [{ required: true, message: "请选择申请开始日期", trigger: "change" }],
                // "xhProject.bidType": [{ required: true, message: "请选择竞价方式", trigger: "change" }],
                // 项目转出人信息
                "xhProjectOut.type": [{ required: true, message: "请选择类型", trigger: "change" }],
                "xhProjectOut.name": [{ required: true, message: "请填写名称", trigger: "blur" }],
                "xhProjectOut.phone": [{ required: true, message: "请填写电话", trigger: "blur" }],
                "xhProjectOut.legal": [{ required: true, message: "请填写法人姓名", trigger: "blur" }],
                "xhProjectOut.idCard": [{ required: true, message: "请填写身份证", trigger: "blur" }],
                "xhProjectOut.bankPhone": [{ required: true, message: "请填写银行预留手机号", trigger: "blur" }],
                "xhProjectOut.bankAccountName": [{ required: true, message: "请填写账户名称", trigger: "blur" }],
                "xhProjectOut.bankName": [{ required: true, message: "请填写开户行名称", trigger: "blur" }],
                "xhProjectOut.bankNo": [{ required: true, message: "请填写银行卡号", trigger: "blur" }],
                // 项目转出信息
                "xhProjectOutMsg.name": [{ required: true, message: "请填写项目名称", trigger: "blur" }],
                "xhProjectOutMsg.price": [{ required: true, message: "请填写价格", trigger: "blur" }],
                "xhProjectOutMsg.priceUnit": [{ required: true, message: "请选择价格单位", trigger: "change" }],
                // "xhProjectOutMsg.depositFlag": [{ required: true, message: "请选择是否需要保证金", trigger: "change" }],
                // "xhProjectOutMsg.depositFee": [{ required: true, message: "请填写保证金", trigger: "blur" }],
                "xhProjectOutMsg.landType": [{ required: true, message: "请选择土地性质", trigger: "change" }],

            },
            areaList: [],
            headers: {
                Authorization: "Bearer " + localStorage.token,
                'Access-Control-Allow-Origin': '*'
            },
            // 地块新增
            plotInfoDialog: false,
            plotIndex: -1,
            xhProjectLand: {
                id: "",
                projectId: "",
                name: "",
                area: 0,
                east: "",
                west: "",
                south: "",
                north: "",
                address: "",
                coorList: [],
                attachmentsList: []
            },

            xhProjectLandRules: {
                name: [{ required: true, message: "请填写地块名称", trigger: "blur" }],
                area: [{ required: true, message: "请填写地块面积", trigger: "blur" }],
                east: [{ required: true, message: "请填写东至", trigger: "blur" }],
                west: [{ required: true, message: "请填写西至", trigger: "blur" }],
                south: [{ required: true, message: "请填写南至", trigger: "blur" }],
                north: [{ required: true, message: "请填写北至", trigger: "blur" }],
                address: [{ required: true, message: "请填写位置", trigger: "blur" }],

            },

            isLook: 0,
            isListing: 0,
            bidTypeList: [],
        };
    },
    beforeRouteLeave(to, from, next) {
        if (!this.isSave && this.isListing != 0) {
            this.$confirm("您还未保存信息，确定需要离开当前页面吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    next();
                })
                .catch(() => { });
        } else {
            next();
        }
    },
    mounted() {
      if (this.$route.query.projectType) {
        this.ruleForm.xhProject.projectType = this.$route.query.projectType;
      }
        let id = this.$route.query.id;
        if (id > 0) {
            if (this.$route.query.isListing) {
                this.isListing = this.$route.query.isListing;
            }
            this.getData(id);
            if (this.$route.query.isLook) {
                this.isLook = this.$route.query.isLook;
            }
        }
        getDict({ dictType: 'bid_type' }).then((res) => {
            this.bidTypeList = res.data
        })
        this.getRealNameInfo();
        this.getAreaList();
    },
    computed: {},
    methods: {
        // 获取账号实名认证信息
        getRealNameInfo() {
            realNameInfo({ id: localStorage.userId }).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    if (!res.data) {
                        this.$message({
                            message: "实名认证后才能发布项目",
                            type: "warning"
                        });
                        this.$router.push({ path: '/authenticationManagement' })
                        return
                    }
                    if (res.data.authFlag == "N") {
                      if (this.isLook != 1) {
                        this.$message({
                          message: "实名认证审核中，暂不能发布项目！",
                          type: "warning"
                        });
                        this.$router.push({
                          path: "/releaseManagement",
                        });
                        return
                      }
                    }

                    if (res.data.userType == '01') {
                        this.ruleForm.xhProjectOut.type = '2'
                    } else {
                        this.ruleForm.xhProjectOut.type = '1'
                    }
                    this.ruleForm.xhProjectOut.name = res.data.userName;
                    this.ruleForm.xhProjectOut.phone = res.data.phonenumber;
                    this.ruleForm.xhProjectOut.idCard = res.data.userCode;
                    if (res.data.companyLegal) {
                    this.ruleForm.xhProjectOut.legal = res.data.companyLegal;
                      this.ruleForm.xhProjectOut.idCard = res.data.companyLegalCode;
                   }
                    this.ruleForm.xhProjectOut.bankPhone = res.data.bankPhone;
                    this.ruleForm.xhProjectOut.bankAccountName = res.data.bankAccountName;
                    this.ruleForm.xhProjectOut.bankNo = res.data.bankNo;
                    this.ruleForm.xhProjectOut.bankName = res.data.bankName;

                }
            });
        },
        // 发布时间限制
        disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7; // 8.64e7 毫秒数代表一天
        },
        // 报名开始时间限制
        disabledDateOne(time) {
            return time.getTime() < new Date(this.ruleForm.xhProject.transferStartDate) - 8.64e7; // 8.64e7 毫秒数代表一天
        },

        // 获取地区列表
        async getAreaList() {
            let res = await areaList()
            console.log(res);
            if (res.code == 200) {
                this.areaList = res.data;
                this.areaList.forEach((item) => {
                    if (item.value == "510000") {
                        item.disabled = false;
                        item.children.forEach((items) => {
                            if (items.value == "511700") {
                                items.disabled = false;
                            } else {
                                items.disabled = true;
                            }
                        })
                    } else {
                        item.disabled = true;
                    }
                })
            }
        },
        // 选完地区
        handleChange(value) {
            this.ruleForm.xhProject.allCode = value.join(","); // 将数组元素连接成一个字符串
            //  arr = str.split(",");   // 将字符串拆分成数组
            console.log(this.ruleForm.xhProject.allCode)
        },
        // 新增坐标
        addCoor(indexs) {
            this.$refs.drawMapRef.showDialog();
        },
        obtainCoordinates(coordinates) {
            let newcoordinates = [];
            coordinates[0].forEach((item) => {
                item = item.lng + "_" + item.lat;
                newcoordinates.push(item);
            })
            this.xhProjectLand.coorList = newcoordinates;
            this.xhProjectLand.coorList.splice(this.xhProjectLand.coorList.length - 1, 1);
        },
        // 添加项目地块
        addProjectPlot() {
            this.plotInfoDialog = true;
        },
        // 编辑地块
        editPlot(item, index) {
            this.plotIndex = index;
            this.plotInfoDialog = true;
            this.xhProjectLand = item;
        },
        // 删除地块
        deletePlot(index) {
            this.ruleForm.xhProjectLandList.splice(index, 1);
        },
        // 保存地块
        savePlot() {
          this.$refs.xhProjectLandRuleForm.validate((valid) => {
            if (valid) {
              //地块名称校验
              if (this.xhProjectLand.name == "") {
                this.$message.error("请填写地块名称");
                return;
              }
              //地块面积校验
              if (this.xhProjectLand.area == 0) {
                this.$message.error("请填写地块面积");
                return;
              }
              //东至
              if (this.xhProjectLand.east == "") {
                this.$message.error("请填写东至");
                return;
              }
              //西至
              if (this.xhProjectLand.west == "") {
                this.$message.error("请填写西至");
                return;
              }
              //南至
              if (this.xhProjectLand.south == "") {
                this.$message.error("请填写南至");
                return;
              }
              //北至
              if (this.xhProjectLand.north == "") {
                this.$message.error("请填写北至");
                return;
              }
              //位置
              if (this.xhProjectLand.address == "") {
                this.$message.error("请填写位置");
                return;
              }
              if (this.xhProjectLand.coorList.length == 0) {
                this.$message.error("请添加坐标范围");
                return;
              }

              if (this.plotIndex >= 0) {
                this.ruleForm.xhProjectLandList[this.plotIndex] = this.xhProjectLand;
              } else {
                this.ruleForm.xhProjectLandList.push(this.xhProjectLand);
              }
              this.xhProjectLand = {
                id: "",
                projectId: "",
                name: "",
                area: 0,
                east: "",
                west: "",
                south: "",
                north: "",
                address: "",
                coorList: [],
                attachmentsList: []
              };
              this.plotIndex = -1;
              this.plotInfoDialog = false;
            } else {
              this.$message.error('请填写必填项');
            }
          });
        },
        //关闭地块弹窗
        handleClose() {
          this.plotInfoDialog = false
          this.xhProjectLand = {}
        },
        // 添加附着物
        addAttachments(item, index) {
            this.xhProjectLand.attachmentsList.push({
                name: "",
            });
        },
        // 删除附着物
        deleteAttachment(index) {
            this.xhProjectLand.attachmentsList.splice(index, 1);
        },
        // 添加项目附件
        addProjectAttachments() {
            this.ruleForm.xhProjectFileList.push({
                id: "",
                projectId: "",
                type: "",
                fileName: "",
                filePath: "",
                status: "1"
            })
        },
        // 同步项目名称
        changeName(value) {
            this.ruleForm.xhProject.name = value;
        },

        beforeUpload(uploadFile, uploadFiles) {

        },
        closeFile(index) {
            this.ruleForm.xhProjectFileList.splice(index, 1);
        },
        //点击下载
        async handDownload(path) {
            await downloadFile(`${import.meta.env.VITE_pan_H5}${path}`);
        },
        //下载文件
        async downloadFile(filepath) {
            const response = await axios({
                url: filepath,
                responseType: 'blob'
            });

            // 生成文件流的URL
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // 创建一个<a>标签并设置相关属性
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute('download', 'file.txt');

            // 将<a>标签添加到文档中，并触发点击事件来开始下载
            document.body.appendChild(link);
            link.click();

            // 下载完成后移除<a>标签及URL
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        // 上传附件
        handleSuccess(res, type) {
            this.ruleForm.xhProjectFileList.push({
                id: "",
                projectId: "",
                type: type,
                fileName: res.originalFilename,
                filePath: res.fileName,
                status: "1"
            });
        },
        // 返回
        goBack() {
            this.$router.push({
                path: "/releaseManagement",
            });
        },
        // 获取项目详情
        async getData(id) {
            let res = await projectDetail({
                projectId: id,
                token: localStorage.token,
            });
            if (res.code == 200) {
                this.ruleForm = res.data;
                this.ruleForm.xhProject.projectType = this.$route.query.projectType;
              // 中标项目转租和流转项目重新挂牌 清空时间   或 我的项目列表 重新挂牌
                if (this.isListing == 1  || this.ruleForm.xhProject.projectType == 2) {
                    this.ruleForm.xhProject.parentId = id;
                    this.ruleForm.xhProject.id = "";
                    this.ruleForm.xhProject.no = "";
                    this.ruleForm.xhProjectOut.id = "";
                    this.ruleForm.xhProjectOut.projectId = "";
                    this.ruleForm.xhProjectOutMsg.id = "";
                    this.ruleForm.xhProjectOutMsg.projectId = "";
                  //发布时间
                  //报名开始时间
                  //报名结束时间
                  //竞价开始时间
                  //竞价结束时间
                  this.ruleForm.xhProject.publishDate = "";
                  this.ruleForm.xhProject.applyStartDate = "";
                  this.ruleForm.xhProject.applyEndDate = "";
                  this.ruleForm.xhProject.bidStartDate = "";
                  this.ruleForm.xhProject.bidEndDate = "";
                    this.ruleForm.xhProjectLandList.forEach((item) => {
                        item.id = "";
                        item.projectId = "";
                    })
                    this.ruleForm.xhProjectFileList.forEach((item) => {
                        item.id = "";
                        item.projectId = "";
                    })
                  this.getRealNameInfo();
                }
                this.allCode = this.ruleForm.xhProject.allCode.split(",");   // 将字符串拆分成数组

            } else {
                this.$message.error(res.errmsg);
            }
        },
        // 保存编辑数据
        submitForm(formName, status) {
            // console.log(this.ruleForm.xhProject.status);
            this.ruleForm.xhProject.status = status;
          if (status == 2) {
            this.$confirm(
                '请确认信息无误，提交后无法修改！',
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
            )
                .then(() => {
                  // 用户点击确定，继续提交操作
                  this.$refs[formName].validate((valid) => {
                    if (valid) {
                      if (this.ruleForm.xhProject.id > 0) {
                        this.editSaveForm();
                      } else {
                        this.saveForm();
                      }
                    } else {
                      return false;
                    }
                  });
                })
                .catch(() => {
                  // 用户取消，不执行任何操作
                  this.$message.info('已取消提交');
                });
          }
          if (status == 1) {

            // 用户点击确定，继续提交操作
            this.$refs[formName].validate((valid) => {
              if (valid) {
                if (this.ruleForm.xhProject.id > 0) {
                  this.editSaveForm();
                } else {
                  this.saveForm();
                }
              } else {
                return false;
              }
            });
          }

        },
        async saveForm() {
            const loading = this.$loading({
                lock: true,
                text: "请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, 0.5)",
            });
            console.log(this.ruleForm.xhProjectOut.allCode)
            this.ruleForm.token = localStorage.token;
            let res = await projectApply(this.ruleForm);
            console.log(res);
            if (res.code == 200) {
                this.isSave = true;
                this.$message.success("项目信息保存成功");
                setTimeout(() => {
                    this.$router.push({
                        path: "/releaseManagement",
                    });
                }, 600);
            } else {
                this.$message.error(res.msg);
            }
            loading.close();
        },

        async editSaveForm() {
            const loading = this.$loading({
                lock: true,
                text: "请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, 0.5)",
            });
            this.ruleForm.token = localStorage.token;
            let res = await projectUpdate(this.ruleForm);
            console.log(res);
            if (res.code == 200) {
                this.isSave = true;
                this.$message.success("项目信息保存成功");
                setTimeout(() => {
                    this.$router.push({
                        path: "/releaseManagement",
                    });
                }, 600);
            } else {
                this.$message.error(res.msg);
            }
            loading.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.attachment_box {
    // display: flex;
    // align-items: flex-end;
    font-size: 20px;
    // margin-right: 20px;
}

.attachment_info {
    width: 100px;
    height: 100px;
    background-color: bisque;
    margin-top: -20px;
    margin-right: 20px;
}

.close_icon {
    position: relative;
    z-index: 1;
}

.attachment_svg {
    width: 50px;
}

.text_overflow {
    width: 80px;
    font-size: 13px;
    line-height: 13px;
    margin-top: 3px;
}

.attachment_info img {
    max-width: 100px;
    height: auto;
    max-height: 100px;
    object-fit: contain;
}
</style>